<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.first_name">
    
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.first_name }} {{activeUserInfo.last_name}}</p>
      <small>Admin</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
 
      <div class="con-img ml-3">
        <img key="onlineImg" src="@/assets/images/portrait/small/avatar-s-27.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 10rem">

          <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="redirect('profile')">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />-->
          <li 
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="redirectProfile"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Edit Profile</span>
          </li>
          <li
						v-if='$store.getters.isRealAdmin'
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="RedirectSettings">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="handleLogout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
          
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    /**
     * Logout API call
     */
    handleLogout() {
      // Call store function
         this.$store
            .dispatch("Logout", this.loginForm)
            .then(() => {
              // Success response
              this.$router.push({ path: "/admin/login" });
            })
            .catch((error) => {
              // Error response
              this.$vs.notify({
                title:'Failed to logout',
                text: error,
                color:'danger',
                position:'top-center'})
               return false;
            });
    },
    redirect(page) {
        this.$router.push('/admin/' + page).catch(() => {})
    },
    RedirectSettings(){
      this.$router.push({ path: '/admin/settings' });
    },
    redirectProfile(){
      this.$router.push({ path: '/admin/profile' });
    }
  }
}
</script>
